import React, { useEffect, useMemo } from "react";
import getProjects from "../helpers/projects";
import { setRandomBackground } from "../helpers/backgroundHelpers";
import { Project } from "../models/project";

const sectionStyle: React.CSSProperties = { marginTop: "2.5rem" };

const Projects: React.FC = () => {
  const projects = useMemo<Project[]>(() => getProjects(), []);

  useEffect(() => {
    setRandomBackground();
  }, []);

  return (
    <div
      style={{
        padding: "2rem 1.25rem 4rem",
        maxWidth: 1000,
        margin: "0 auto",
        color: "#fff",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        lineHeight: 1.45,
      }}
    >
      <header style={{ marginBottom: "2rem" }}>
        <h1 style={{ margin: 0, fontSize: "2.4rem", letterSpacing: "0.5px" }}>
          Projects I've worked on
        </h1>
      </header>

      <section style={sectionStyle} aria-labelledby="projects-heading">
        <ol
          style={{
            listStyle: "none",
            padding: 0,
            margin: "1.25rem 0 0",
            display: "flex",
            flexDirection: "column",
            gap: "1.75rem",
          }}
        >
          {projects.map((p, i) => {
            return (
              <li
                key={`${p.Title}-${i}`}
                style={{
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  borderRadius: 12,
                  padding: "1.1rem 1.2rem 1.15rem",
                  backdropFilter: "blur(4px)",
                }}
              >
                <div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: "1.15rem",
                      fontWeight: 600,
                      letterSpacing: 0.3,
                    }}
                  >
                    {p.Title}
                  </h3>
                  <div style={{ opacity: 0.85 }}>{p.Description}</div>
                  <div>
                    <img
                      src={p.ImagePath}
                      alt={p.Title}
                      style={{
                        maxWidth: "100%",
                        borderRadius: 8,
                        marginTop: "0.75rem",
                      }}
                    />
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      </section>

      {/* Optional PDF embed example:
        <object data="/resume.pdf" type="application/pdf" width="100%" height="800px">
          <p>Your browser does not support embedded PDFs. <a href="/resume.pdf">Download the PDF</a>.</p>
        </object>
      */}
    </div>
  );
};

export default Projects;
